import {
  SET_MULTIPLE_SHOW,
  SET_POSITION_ALIGN_SHOW,
  SET_MUTLTIPLE_FIND_REPLACE_SHOW,
  SET_FRAM_SPLIT_ERROR,
  SET_TABLE_SELECT_CELL,
  SET_MUTILE_FIND_DATA,
  SET_CREATE_MUTILE,
  SET_SHOW_FIND_POSITION,
  SET_SHOW_FIND_POSITION_DATA,
  SET_SHOW_FIND_FRAME,
  SET_FRAME_SPLIT_VALUE,
  UPDATE_FRAME_SPLIT_DATA,
  UPDATE_FRAME_GAP_DATA,
  UPDATE_SHOT_CHANGE_ERROR_DATA,
} from '../actions/types';
import React from 'react';

const initialState = {
  isShowMutileFindDialog: false,
  isPositionAlignDialog: false,
  isShowMultipleFindReplace: false,
  isShowFrameSplitError: false,
  currentCellSelect: 0, //當前選擇的行數

  //客製搜尋
  multipleFindData: [],

  //是否新增客製化
  isOpenCreateMultipleView: false,

  //搜尋position
  // findPositionTargetData:[],
  findPositionTargetData: [],
  //搜尋position目標位置
  // findPositionSelectRowCol:null,
  findPositionSelectRowCol: [],
  //搜尋position列表選擇
  isShowFindPositionList: false,

  // findPositionTargetData:[],
  findFrameSplitValue: 2,
  findFrameTargetData: [
    {
      type: 'Out',
      rowIndex: 0,
      nextIndex: 1,
      position: '1',
      outTime: '00:00:00.12',
    },
  ],
  findShotChangeErrorData: [
    {
      type: 'Out',
      rowIndex: 0,
      nextIndex: 1,
      position: '1',
      outTime: '00:00:00.12',
    },
  ],
  //搜尋position目標位置
  // findPositionSelectRowCol:null,
  findFrameSelectRowCol: [0, 9],
  //搜尋frame列表選擇
  isShowFindFrameList: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    //更新錯誤的FRAME DATA
    case UPDATE_FRAME_SPLIT_DATA:
      return {
        ...state,
        findFrameTargetData: action.payload,
      };

    case UPDATE_FRAME_GAP_DATA:
      return {
        ...state,
        findFrameGapErrorData: action.payload,
      };

    //更新錯誤的FRAME DATA
    case UPDATE_SHOT_CHANGE_ERROR_DATA:
      return {
        ...state,
        findShotChangeErrorData: action.payload,
      };

    //設定要檢查的Frame資料
    case SET_FRAME_SPLIT_VALUE:
      return {
        ...state,
        findFrameSplitValue: action.payload,
      };

    //是否顯示 Frame 的列表
    case SET_SHOW_FIND_FRAME:
      return {
        ...state,
        isShowFindFrameList: action.payload,
      };

    //儲存 POSITION 的結果
    case SET_SHOW_FIND_POSITION_DATA:
      return {
        ...state,
        findPositionTargetData: action.payload,
      };
    //是否顯示POSITION 的列表
    case SET_SHOW_FIND_POSITION:
      return {
        ...state,
        isShowFindPositionList: action.payload,
      };
    //新增客製
    case SET_CREATE_MUTILE:
      return {
        ...state,
        isOpenCreateMultipleView: action.payload,
      };
    //客製
    case SET_MUTILE_FIND_DATA:
      return {
        ...state,
        multipleFindData: action.payload,
      };
    //現在選到的位置
    case SET_TABLE_SELECT_CELL:
      return {
        ...state,
        currentCellSelect: action.payload,
      };

    case SET_MULTIPLE_SHOW:
      return {
        ...state,
        isShowMutileFindDialog: action.payload,
      };

    case SET_POSITION_ALIGN_SHOW:
      return {
        ...state,
        isPositionAlignDialog: action.payload,
      };

    case SET_MUTLTIPLE_FIND_REPLACE_SHOW:
      return {
        ...state,
        isShowMultipleFindReplace: action.payload,
      };

    case SET_FRAM_SPLIT_ERROR:
      return {
        ...state,
        isShowFrameSplitError: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/FindReducer.js